import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { Article } from '@interfaces/homepage';
import { OfferOption } from '@utils/backend-api/subscribe';
import { Reporter } from '@utils/backend-api/subscribe';

import { SubscribeProps } from '../Subscribe';
import Content from './Content';

const queryClient = new QueryClient();

export interface InsightArticle {
  topic: string;
  articles: Article[];
}

export interface AsiaTechCoverageProps extends SubscribeProps {
  env: Env;
  insightArticlesByTopic: InsightArticle[];
  reporters: Reporter[];
  ypOffer: OfferOption;
}

const AsiaTechCoverage = (props: AsiaTechCoverageProps) => {
  const {
    env,
    initialCurrentUser,
    isGdprRequired,
    isYPEligible,
    stripeCustomerId,
    subscribePrefillToken,
    subscriptionStatus,
    userDobVerified,
    userEmail,
    userFullName,
    userId,
    userNextBillingDate,
  } = props;

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
    >
      <SubscribeFormProvider
        user={{
          dobVerified: userDobVerified,
          email: userEmail,
          id: userId,
          isYPEligible,
          name: userFullName,
          nextBillingDate: userNextBillingDate,
          prefillToken: subscribePrefillToken,
          stripeCustomerId,
          subscriptionStatus,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <Content {...props} />
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default AsiaTechCoverage;
